<template lang="pug">
#BusinessGroupView.custom-container.pb-3
  .section-title Detalle Tarea
  b-breadcrumb.breadcrumb(:items="breadcrumbs")
  .table-view.pb-3
    h3.detail-title Editar Tarea {{ task ? task.name : '' }}
    hr
    b-container(fluid)
      TaskForm(editMode)
    ListBusinessByTask
</template>
<script>
import TaskForm from "../components/task/TaskForm.vue";
import ListBusinessByTask from '../components/task/ListBusinessByTask.vue'
import { mapGetters, mapActions } from 'vuex'
export default {
  data(){
    return{
      breadcrumbs: [
        {
          text: 'Inicio',
          to: { name: 'Home' }
        },
        {
          text: 'Tareas',
          to: { name: 'Tasks' }
        },
        {
          text: 'Detalle Tarea',
          active: true
        }
      ]
    }
  },
  methods: {
    ...mapActions(['getTask'])
  },
  computed: {
    ...mapGetters(['task'])
  },
  components: {
    TaskForm,
    ListBusinessByTask
  },
  created () {
    this.getTask(this.$route.params.taskId)
  }
};
</script>
